// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_3URHo){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_1S2-X .dualColumn_1K2KY{display:flex;align-content:space-between}.nsAddressForm_1S2-X .dualColumn_1K2KY .firstCol_2tldz{margin-right:20px}.optional_3ZXGE{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_3URHo",
	"nsAddressForm": "nsAddressForm_1S2-X",
	"dualColumn": "dualColumn_1K2KY",
	"firstCol": "firstCol_2tldz",
	"optional": "optional_3ZXGE"
};
module.exports = exports;
